import { render, staticRenderFns } from "./ModeratedMessage.vue?vue&type=template&id=3055ba24&scoped=true&"
import script from "./ModeratedMessage.vue?vue&type=script&lang=js&"
export * from "./ModeratedMessage.vue?vue&type=script&lang=js&"
import style0 from "./ModeratedMessage.vue?vue&type=style&index=0&id=3055ba24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3055ba24",
  null
  
)

export default component.exports